import { safeLs } from 'shared/storages';

export const setAuthClientId = (clientId: string) => {
  safeLs.add('SAMOLET_OAUTH2_PKCE_CLIENT_ID', clientId);
};
